module.exports = __webpack_public_path__ + "images/placeholder-delay-statistics-mobile-223787e68fcdf58a746fd17eb07575c7.png";